module.exports = __webpack_public_path__ + "static/media/nytimes.com_interactive_2016_08_11_magazine_isis-middle-east-arab-spring-fractured-lands.html_plot.f309b2ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/nytimes.com_interactive_2016_08_11_magazine_isis-middle-east-arab-spring-fractured-lands.html_plot.png
// module id = 411
// module chunks = 0